import { HttpInterceptorFn } from '@angular/common/http';
import { finalize } from 'rxjs';

export const loaderInterceptor: HttpInterceptorFn = (request, next) => next(request).pipe(finalize(() => undefined));
